import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText, FDHeadlineText } from '@facet-wealth/design';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { AccountOpeningV2BeneficiaryAllocations } from './AccountOpeningV2BeneficiaryAllocations';
import { AccountOpeningV2BeneficiaryAllocationsStepLayout } from './AccountOpeningV2BeneficiaryAllocationsStepLayout';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => Text,
    _customProps: { Component: FDHeadlineText, size: 'sm' },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => Text,
    _customProps: { Component: FDBodyText, size: 'md' },
  }, overrideReadOnly)
  .nameOverride('beneficiaryAllocations', {
    _component: () => AccountOpeningV2BeneficiaryAllocations,
  }, overrideReadOnly);

export const AccountOpeningV2BeneficiaryAllocationsStep = () => {
  const { pageContentResource, setPageContentCollection } = usePageContentContext();

  return (
    <MetaResourceRenderer
      layout={AccountOpeningV2BeneficiaryAllocationsStepLayout}
      resource={pageContentResource}
      onSubmit={setPageContentCollection}
      metaOverrideSet={metaOverrideSet}
    />
  );
};
